/** Returns the sum of margins in a given direction
 * for set of direct descendant of the element that has
 * the largest margin values.
 *
 * Params:
 * element: the element to search for direct descendants
 * selector: a CSS selector to filter the direct descendants
 * direction: "vertical" or "horizontal"
 */
export function getElementDescendantsMaxMargins(element, selector, direction) {
  if (!element || !direction) {
    console.error("getElementMargins: Missing one of parameters");
    return;
  }

  const allowedDirections = ["vertical", "horizontal"];
  if (!allowedDirections.includes(direction)) {
    console.error(`getElementMargins: Invalid direction: ${direction}. Allowed values: ${allowedDirections}`);
    return;
  }

  const children = Array.from(element.children).filter(child => child.matches(selector));
  if (children.length === 0) {
    return direction === "vertical"
      ? { marginTop: 0, marginBottom: 0 }
      : { marginLeft: 0, marginRight: 0 };
  }

  let highestSum = -Infinity;

  for (const child of children) {
    const style = getComputedStyle(child);

    if (direction === "vertical") {
      const marginTop = parseFloat(style.marginTop) || 0;
      const marginBottom = parseFloat(style.marginBottom) || 0;
      const sum = marginTop + marginBottom;
      if (sum > highestSum) {
        highestSum = sum;
      }
    } else {
      const marginLeft = parseFloat(style.marginLeft) || 0;
      const marginRight = parseFloat(style.marginRight) || 0;
      const sum = marginLeft + marginRight;
      if (sum > highestSum) {
        highestSum = sum;
      }
    }
  }

  return highestSum;
}

/** Returns the total height of an element including margins */
export function getElementTotalHeight(element) {
  if (!element) {
    console.error("getElementTotalHeight: Missing element parameter");
    return;
  }

  const heightWithPadding = element.getBoundingClientRect().height;
  const style = getComputedStyle(element);
  const marginTop = parseFloat(style.marginTop) || 0;
  const marginBottom = parseFloat(style.marginBottom) || 0;

  return heightWithPadding + marginTop + marginBottom;
}

/** Returns the total width of an element including margins */
export function getElementTotalWidth(element) {
  if (!element) {
    console.error("getElementTotalHeight: Missing element parameter");
    return;
  }

  const widthWithPadding = element.getBoundingClientRect().width;
  const style = getComputedStyle(element);
  const marginLeft = parseFloat(style.marginLeft) || 0;
  const marginRight = parseFloat(style.marginRight) || 0;

  return widthWithPadding + marginLeft + marginRight;
}
